import { Collapse, Table } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const EFileSummaryCard = ({ ...props }) => {
  const { Panel } = Collapse;
  const { isCollapse } = props;
  const { activeEFileOption } = useSelector((state: RootState) => state.eFileApi);
  const { activeCaseNumber, caseMaster } = useSelector((state: RootState) => state.global);
  const delayedFee = (activeEFileOption?.FeeAmount > 0 && !activeEFileOption.IsFeeImmediate) ? " (delayed fee)" : "";
  const columns = [
    {
      title: '',
      dataIndex: 'field',
      key: 'field'
    },
    {
      title: '',
      dataIndex: 'value',
      key: 'value'
    },

  ]
  const dataSource = [
    { key: '1', field: 'Case Number', value: activeCaseNumber },
    { key: '2', field: 'E-File Option', value: activeEFileOption?.OptionId || 'Not Selected' },
    { key: '3', field: 'E-File Code', value: activeEFileOption?.Code || 'Not Selected' },
    { key: '4', field: 'E-Filing Fee', value: `$ ${Number(activeEFileOption?.FeeAmount)?.toFixed(2) ?? "0.00"}` + delayedFee },
    { key: '5', field: 'Defendant Name', value: caseMaster?.summary.MAIN[0].NAME },
    { key: '6', field: 'Defendant Address', value: caseMaster?.summary.MAIN[0].ADDRESS1 },
    { key: '7', field: 'Violation A Charge', value: activeCaseNumber },
    { key: '8', field: 'Remaining Due for Case', value: `$ ${Number(activeEFileOption?.FeeAmount)?.toFixed(2) ?? "0.00"}` },
    { key: '9', field: 'Case Status', value: caseMaster?.summary?.MAIN[0].STATUS },
  ]
  return (
    <div>
      {
        isCollapse ? (
          <Collapse>
            <Panel header={<h1>E-File Case Summary</h1>} key="1">
              <Table columns={columns} dataSource={dataSource} pagination={false} size='small' />
            </Panel>
          </Collapse>) :
          (<div>
            <h1>E-File Case Summary</h1>
            <Table columns={columns} dataSource={dataSource} pagination={false} size='small' />
          </div>
          )
      }
    </div>
  )
};

export default EFileSummaryCard;
